export var SectionSide;
(function (SectionSide) {
  SectionSide["top"] = "top";
  SectionSide["bottom"] = "bottom";
  SectionSide["vMiddle"] = "vMiddle";
  SectionSide["vAuto"] = "vAuto";
  SectionSide["all"] = "all";
})(SectionSide || (SectionSide = {}));